import graphql from '../common/graphql';
import { ForecastChartType, tilesetQuery, getChartTimes } from '../common/graphql/charts';
import { numberOfForecastDays } from '../constants';

/* eslint-disable import/prefer-default-export */
export const SET_WIND_COLORS = 'SET_WIND_COLORS';
export const SET_WIND_ARROW_OPTIONS = 'SET_WIND_ARROW_OPTIONS';
export const SET_SWELL_HEIGHT_COLORS = 'SET_SWELL_HEIGHT_COLORS';
export const SET_SWELL_HEIGHT_ARROW_OPTIONS = 'SET_SWELL_HEIGHT_ARROW_OPTIONS';
export const SET_SWELL_PERIOD_COLORS = 'SET_SWELL_PERIOD_COLORS';
export const SET_SWELL_PERIOD_ARROW_OPTIONS = 'SET_SWELL_PERIOD_ARROW_OPTIONS';
export const SET_SWELL_PERIOD_PARTICLE_OPTIONS = 'SET_SWELL_PERIOD_PARTICLE_OPTIONS';
export const SET_SWELL_HEIGHT_PARTICLE_OPTIONS = 'SET_SWELL_HEIGHT_PARTICLE_OPTIONS';
export const SET_WIND_PARTICLE_OPTIONS = 'SET_WIND_PARTICLE_OPTIONS';
export const OVERWRITE_CHART_CONFIG = 'OVERWRITE_CHART_CONFIG';
export const FETCH_CHART_TILES = 'FETCH_CHART_TILES';
export const FETCH_CHART_TILES_SUCCESS = 'FETCH_CHART_TILES_SUCCESS';
export const FETCH_CHART_TILES_FAILURE = 'FETCH_CHART_TILES_FAILURE';

export const dataLayer = {
  wind: {
    setWindColors: colors => ({
      type: SET_WIND_COLORS,
      colors,
    }),
    setWindArrowOptions: options => ({
      type: SET_WIND_ARROW_OPTIONS,
      options,
    }),
    setWindParticleOptions: options => ({
      type: SET_WIND_PARTICLE_OPTIONS,
      options,
    }),
  },
  swell: {
    setSwellHeightColors: colors => ({
      type: SET_SWELL_HEIGHT_COLORS,
      colors,
    }),
    setSwellHeightArrowOptions: options => ({
      type: SET_SWELL_HEIGHT_ARROW_OPTIONS,
      options,
    }),
    setSwellHeightParticleOptions: options => ({
      type: SET_SWELL_HEIGHT_PARTICLE_OPTIONS,
      options,
    }),
  },
  period: {
    setSwellPeriodColors: colors => ({
      type: SET_SWELL_PERIOD_COLORS,
      colors,
    }),
    setSwellPeriodArrowOptions: options => ({
      type: SET_SWELL_PERIOD_ARROW_OPTIONS,
      options,
    }),
    setSwellPeriodParticleOptions: options => ({
      type: SET_SWELL_PERIOD_PARTICLE_OPTIONS,
      options,
    }),
  },
  setChartConfig: config => ({
    type: OVERWRITE_CHART_CONFIG,
    config,
  }),
};

export const fetchTilesets = isPremium => async (dispatch) => {
  dispatch({
    type: FETCH_CHART_TILES,
  });
  const numberOfDays = isPremium ? numberOfForecastDays.PREMIUM : numberOfForecastDays.FREE;

  const requests = Object.values(ForecastChartType).map((type) => {
    const [start, end] = getChartTimes(type, numberOfDays);
    return graphql(tilesetQuery(type, start, end));
  });

  try {
    const responses = await Promise.all(requests);
    const tiles = responses.reduce((allTiles, response) => {
      const {
        data: {
          forecastCharts: [{ type, tiles: data }],
        },
      } = response;
      return {
        ...allTiles,
        [type]: data,
      };
    }, {});

    dispatch({
      type: FETCH_CHART_TILES_SUCCESS,
      tiles,
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);

    dispatch({
      type: FETCH_CHART_TILES_FAILURE,
      error,
    });
  }
};



// WEBPACK FOOTER //
// ./src/actions/charts.js